import { Typography, Grid } from "@mui/material";
import ControlledDatePicker from "components/Controller/ControlledDatePicker";
import ControlledTextField from "components/Controller/ControlledTextField";
import { CustomizedBox } from "components/Custom/CustomizedBox";
import { useDisable } from "hooks/use-disable";
import { useFormContext } from "react-hook-form";
import { IDeliveryTrip } from "types/Logistic/deliveryTrip";

// 86d37db3t — section renamed from "บันทึกการจ่ายเงินพนักงาน" →
// "หลักฐานการจ่ายเงิน". Fields are freely editable at any time; the
// per-status isShow gate and paymentStatus lock are gone.
// Layout: date picker (1/3 width) + full-width detail textarea below.
const DateOfPayment = () => {
  const { control } = useFormContext<IDeliveryTrip>();
  const [disabled] = useDisable();

  return (
    <CustomizedBox margin={"1rem 0rem 0rem 0rem"}>
      <Typography fontWeight={600} mb={1}>
        หลักฐานการจ่ายเงิน
      </Typography>
      <Grid container spacing={1.5}>
        <Grid item xs={12} sm={12} md={4}>
          <ControlledDatePicker
            control={control}
            name="payment_date"
            label={"วันที่จ่ายเงิน"}
            viewMode={disabled}
          />
        </Grid>
        <Grid item xs={12}>
          <ControlledTextField
            name="payment_detail"
            control={control}
            label={"รายละเอียด"}
            multiline
            rows={4}
            viewMode={disabled}
          />
        </Grid>
      </Grid>
    </CustomizedBox>
  );
};

export default DateOfPayment;
